import Const from 'constants';
import {combineReducers} from 'redux';
import {getDefaultExposure} from 'helpers/player-helper';

const defaultState = {
    data: {},
    has(team) {
        return this.data.hasOwnProperty(team);
    },
    getValue(team) {
        if (this.has(team)) {
            return this.data[team];
        }
        return getDefaultExposure('max');
    },
    all() {
        return cp(this.data);
    },
};

export function exposureMax(state = defaultState, action) {
    if (action.type === Const.SET_EXPOSURE_MAX_OF_USED_TEAM) {
        const data = cp(state.data);
        data[action.teamName] = action.exposureMaxPercent;

        state = {...state, data};
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {...defaultState};
    }

    return state;
}

const reducers = {
    exposureMax,
};

export default combineReducers(reducers);
